module.exports = __webpack_public_path__ + "img/sold_egg.f6774c5d.svg";